export const DEFAULT = {
  NORMAL: {
    '--standard-normal-pure-black-color': '#000000',
    '--standard-normal-pure-white-color': '#ffffff',
    '--standard-normal-primary-color': '#0E151D',
    '--standard-normal-secondary-color': '#1A2837',
    '--standard-normal-primary-text-color': '#FFFFFF',
    '--standard-normal-primary-font-family': 'var(--app-rubik-font-family)',
    '--standard-normal-secondary-font-family': 'var(--app-rubik-font-family)',
    '--standard-normal-secondary-text-color': 'rgba(255, 255, 255, 0.5)',
    '--standard-normal-border-color': '#253B53',
    '--standard-normal-accent-color': '#4A57F9',

    '--standard-normal-success-color': '#28e48a',
    '--standard-normal-success-transparent-color': '#28e4897a',
    '--standard-normal-error-color': '#ff8170',
    '--standard-normal-error-transparent-color': '#ff81707a',

    '--standard-normal-app-background-color': 'var(--standard-normal-primary-color)',

    // HEADER
    '--standard-normal-app-header-background-color': 'var(--standard-normal-secondary-color)',
    '--standard-normal-app-header-currency-font-color': 'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-header-currency-font-size': 'var(--crash-game-text-md)',
    '--standard-normal-app-header-currency-font-weight': '500',
    '--standard-normal-app-header-balance-font-color': 'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-header-balance-font-size': 'var(--crash-game-text-md)',
    '--standard-normal-app-header-balance-font-weight': '500',
    '--standard-normal-app-header-balance-positive-color': 'var(--standard-normal-success-color)',
    '--standard-normal-app-header-balance-negative-color': 'var(--standard-normal-error-color)',

    // TOGGLE (generic tokens — shared by the one Toggle component across modes)
    '--app-toggle-circle-background-color': 'var(--standard-normal-secondary-color)',
    '--app-toggle-body-before-background-color': 'var(--standard-normal-border-color)',
    '--app-toggle-body-after-background-color': 'var(--standard-normal-accent-color)',
    '--app-toggle-white-background-color': 'var(--standard-normal-pure-white-color)',

    // MENU
    '--standard-normal-app-menu-main-background-color': 'var(--standard-normal-primary-color)',
    '--standard-normal-app-menu-option-font-color': 'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-menu-option-font-size': 'var(--crash-game-text-sm)',
    '--standard-normal-app-menu-option-font-weight': '400',

    '--standard-normal-app-menu-navigator-title-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-menu-navigator-title-font-size': 'var(--crash-game-text-md)',
    '--standard-normal-app-menu-navigator-title-font-weight': '500',

    // LAST CRASH MULTIPLIERS
    '--standard-normal-app-last-crash-multipliers-font-color':
      'var(--standard-normal-primary-color)',
    '--standard-normal-app-last-crash-multipliers-font-size': 'var(--crash-game-text-11)',
    '--standard-normal-app-last-crash-multipliers-font-weight': '500',
    '--standard-normal-app-last-crash-multipliers-border-radius': '5px',

    '--standard-normal-app-last-crash-multipliers-level-1-bg-color': '#BFC5CE',
    '--standard-normal-app-last-crash-multipliers-level-2-bg-color': '#6CB7FF',
    '--standard-normal-app-last-crash-multipliers-level-3-bg-color': '#58E38A',
    '--standard-normal-app-last-crash-multipliers-level-4-bg-color': '#FFD84D',
    '--standard-normal-app-last-crash-multipliers-level-5-bg-color': '#FFB05A',
    '--standard-normal-app-last-crash-multipliers-level-6-bg-color': '#FF8A80',
    '--standard-normal-app-last-crash-multipliers-level-7-bg-color': '#C9A2FF',
    '--standard-normal-app-last-crash-multipliers-level-8-bg-color': '#FFE066',

    // HOW TO PLAY  (Rocket Blast identity — blast orange)
    '--standard-normal-app-how-to-play-accent-color': '#FF6A2B',
    '--standard-normal-app-how-to-play-heading-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-how-to-play-heading-font-size': 'var(--crash-game-text-xl)',
    '--standard-normal-app-how-to-play-heading-font-weight': '700',
    '--standard-normal-app-how-to-play-body-font-color':
      'var(--standard-normal-secondary-text-color)',
    '--standard-normal-app-how-to-play-body-font-size': 'var(--crash-game-text-13)',
    '--standard-normal-app-how-to-play-visual-bg-color': 'var(--standard-normal-secondary-color)',
    '--standard-normal-app-how-to-play-visual-border-color': 'var(--standard-normal-border-color)',
    '--standard-normal-app-how-to-play-success-color': 'var(--standard-normal-success-color)',
    '--standard-normal-app-how-to-play-error-color': 'var(--standard-normal-error-color)',
    '--standard-normal-app-how-to-play-dot-color': 'rgba(255, 255, 255, 0.14)',
    '--standard-normal-app-how-to-play-nav-bg-color': 'rgba(255, 255, 255, 0.04)',

    '--standard-normal-app-activity-panels-tab-font-color':
      'var(--standard-normal-secondary-text-color)',
    '--standard-normal-app-activity-panels-tab-font-size': 'var(--crash-game-text-md)',
    '--standard-normal-app-activity-panels-tab-font-weight': '500',
    '--standard-normal-app-activity-panels-border-color': 'transparent',

    '--standard-normal-app-activity-panels-tab-active-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-activity-panels-active-tab-font-size': 'var(--crash-game-text-md)',
    '--standard-normal-app-activity-panels-active-tab-font-weight': '500',
    '--standard-normal-app-activity-panels-active-border-color':
      'var(--standard-normal-accent-color)',

    '--standard-normal-app-spinning-loader-background-color': 'var(--standard-normal-accent-color)',

    '--standard-normal-app-pagination-page-background-color':
      'var(--standard-normal-secondary-color)',
    '--standard-normal-app-pagination-page-font-color': 'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-pagination-page-font-size': 'var(--crash-game-text-xs)',
    '--standard-normal-app-pagination-page-font-weight': '400',

    '--standard-normal-app-pagination-active-page-background-color':
      'var(--standard-normal-accent-color)',
    '--standard-normal-app-pagination-active-page-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-pagination-active-page-font-size': 'var(--crash-game-text-xs)',
    '--standard-normal-app-pagination-active-page-font-weight': '500',

    '--standard-normal-app-pagination-skip-page-background-color':
      'var(--standard-normal-secondary-color)',
    '--standard-normal-app-pagination-skip-page-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-pagination-skip-page-font-size': 'var(--crash-game-text-xs)',
    '--standard-normal-app-pagination-skip-page-font-weight': '400',

    '--standard-normal-app-transactions-header-element-font-color':
      'var(--standard-normal-secondary-text-color)',
    '--standard-normal-app-transactions-header-element-font-size': 'var(--crash-game-text-2xs)',
    '--standard-normal-app-transactions-header-element-font-weight': '400',

    '--standard-normal-app-transactions-bet-card-background-color':
      'var(--standard-normal-secondary-color)',
    '--standard-normal-app-transactions-bet-card-border-color':
      'var(--standard-normal-border-color)',
    '--standard-normal-app-transactions-bet-card-border-radius': '5px',

    '--standard-normal-app-transactions-bet-card-date-time-font-color':
      'var(--standard-normal-secondary-text-color)',
    '--standard-normal-app-transactions-bet-card-date-time-font-size': 'var(--crash-game-text-2xs)',
    '--standard-normal-app-transactions-bet-card-date-time-font-weight': '400',

    '--standard-normal-app-transactions-bet-card-subtype-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-transactions-bet-card-subtype-font-size': 'var(--crash-game-text-2xs)',
    '--standard-normal-app-transactions-bet-card-subtype-font-weight': '400',

    '--standard-normal-app-transactions-bet-card-stake-font-color':
      'var(--standard-normal-primary-text-color)',
    '--standard-normal-app-transactions-bet-card-stake-font-size': 'var(--crash-game-text-2xs)',
    '--standard-normal-app-transactions-bet-card-stake-font-weight': '400',

    '--standard-normal-app-transactions-bet-card-payout-multiplier-won-font-color':
      'var(--standard-normal-success-color)',
    '--standard-normal-app-transactions-bet-card-payout-multiplier-lost-font-color':
      'var(--standard-normal-error-color)',

    '--standard-normal-app-transactions-bet-card-payout-multiplier-won-border-color':
      'var(--standard-normal-success-color)',
    '--standard-normal-app-transactions-bet-card-payout-multiplier-lost-border-color':
      'var(--standard-normal-error-color)',

    '--standard-normal-app-transactions-bet-card-payout-multiplier-border-radius': '20px',

    '--standard-normal-app-transactions-bet-card-payout-multiplier-font-size':
      'var(--crash-game-text-2xs)',
    '--standard-normal-app-transactions-bet-card-payout-multiplier-font-weight': '500',

    '--standard-normal-app-transactions-bet-card-payout-won-font-color':
      'var(--standard-normal-success-color)',

    '--standard-normal-app-transactions-bet-card-payout-lost-font-color':
      'var(--standard-normal-error-color)',
    '--standard-normal-app-transactions-bet-card-payout-font-size': 'var(--crash-game-text-2xs)',
    '--standard-normal-app-transactions-bet-card-payput-font-weight': '400',
  },
  MINI: {
    '--standard-mini-pure-black-color': '#000000',
    '--standard-mini-pure-white-color': '#ffffff',
    '--standard-mini-primary-color': '#000',
    '--standard-mini-secondary-color': '#000012',
    '--standard-mini-primary-text-color': '#fff',
    '--standard-mini-font-family': 'var(--app-theme-default-font-family)',
  },
}
